import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ToastEvent {
  id: number;
  type: 'success' | 'error' | 'neutral';
  messages: string[];
  duration: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toasts$ = new BehaviorSubject<ToastEvent[]>([]);
  private nextId = 0;

  /** Observable of currently active toasts. */
  get events$(): Observable<ToastEvent[]> {
    return this.toasts$.asObservable();
  }

  showSuccess(message: string, duration = 6000): void {
    this.addToast('success', [message], duration);
  }

  showError(message: string, duration = 12000): void {
    this.addToast('error', [message], duration);
  }

  /**
   * Show a multi-line message toast.
   * Supports string[] for multi-line display as specified.
   */
  showMessage(messages: string[], duration = 12000): void {
    this.addToast('neutral', messages, duration);
  }

  dismiss(id: number): void {
    const current = this.toasts$.value;
    this.toasts$.next(current.filter(t => t.id !== id));
  }

  private addToast(type: ToastEvent['type'], messages: string[], duration: number): void {
    const id = this.nextId++;
    const toast: ToastEvent = { id, type, messages, duration };
    this.toasts$.next([...this.toasts$.value, toast]);

    if (duration > 0) {
      setTimeout(() => this.dismiss(id), duration);
    }
  }
}
